import { gray } from "../themePrimitives";

export default {
	styleOverrides: {
		root: {
			border: 'none',
		},
		input: {
			'&::placeholder': {
				opacity: 0.7,
				color: gray[100],
			},
		},
	},
}
